import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen text-white pt-20 flex items-center justify-center">
      <div className="text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-blue-600 mb-4">404</h1>
          <h2 className="text-4xl font-bold mb-4">Page Not Found</h2>
          <p className="text-xl text-gray-300 max-w-md mx-auto mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>
        
        <div className="space-y-4">
          <Link 
            to="/" 
            className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg font-medium transition-colors duration-300"
          >
            Go Home
          </Link>
          
          <div className="text-gray-400">
            <p>Or navigate to:</p>
            <div className="flex flex-wrap justify-center gap-4 mt-3">
              <Link to="/services" className="text-blue-400 hover:text-blue-300 transition-colors">
                Services
              </Link>
              <Link to="/insights" className="text-blue-400 hover:text-blue-300 transition-colors">
                Insights
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
